module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-joker.c92e237c.png";